export default {"src":"/_next/static/media/mobile-hamburger-icon.558633b9.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};